<template>
	<!--    module是各模块自定义参数-->
	<div class="homePage_inlinet" v-if="module.show" :key="module.key">
		<Panel hasShadow style="height: 488px" class="rank-pannel">
			<!--        顶部-->
			<div class="flex-row flex-just-between">
				<span class="font-h2-medium">{{ module.title }}</span>
				<div class="flex-row-align-center">
					<!--            平台选项-->
					<el-dropdown
						class="ml-8"
						v-if="module.platformSelect && $isAllPF(platformId)"
						@command="platform_id => handleCommand(platform_id, module.key)"
					>
						<div class="home_inlineTitle_select color-gy-9">
							<platform-icon :platformId="module.platform_id" />
							<span class="fz-12 ml-4">{{ module.platform_id | formatPlatformName }}</span>
							<i class="ml-4 el-icon-arrow-down"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="item in canShowPlatformList" :command="item.value" :key="item.value">
								<platform-icon :platformId="item.value" />
								{{ item.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<!--            角色选项-->
					<el-dropdown class="ml-8" v-if="module.key === 'RankingStaff'" @command="role => handleCommand(role[0], module.key)">
						<div class="home_inlineTitle_select color-gy-9">
							<span class="fz-12 ml-4">{{ roleMap.get(module.role)['title'] }}</span>
							<i class="ml-4 el-icon-arrow-down"></i>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="value in roleMap" :command="value" :key="value[0]">
								{{ value[1]['title'] }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<div
						v-if="module.showMore"
						class="font-h6-regular ml-16 cursor-pointer flex-row-align-center"
						@click="skipUrl(module.platform_id, module.key)"
						style="height: 34px"
					>
						更多
						<i class="el-icon-arrow-right"></i>
					</div>
				</div>
			</div>
			<!--        排行榜内容-->
			<div class="flex-column" v-loading="module.loading" style="height: 100%">
				<div
					v-for="(item, index) in module.list"
					:key="item.key"
					class="home_rankingItem flex-row-center-between pt-10 pb-10 pl-12 pr-12 flex-just-between mt-12"
				>
					<div class="flex-row-align-center">
						<img v-if="index < 3" class="home_rankingItem_icon mr-12" :src="icon[index]" />
						<span v-else class="home_rankingItem_icon mr-12 Barlow-Bold fz-16 flex-row-align-center flex-just-center">{{ index + 1 }}</span>
						<div v-if="module.showImg" style="width: 48px; height: 48px">
							<el-image v-if="module.key === 'RankingGood'" style="width: 48px; height: 48px" class="radius-4" fit="cover" :src="item.imgUrl" lazy>
								<template v-slot:error>
									<img src="@/assets/public/img-empty1.png" alt="" />
								</template>
							</el-image>
							<yx-avatar v-else :size="48" :src="item.imgUrl" />
						</div>
						<div class="ml-12">
							<div class="font-h6-regular flex-row-align-center line-ellipsis-1" style="word-break: break-all">
								<platform-icon :platformId="item.platform_id" v-if="module.showIcon" class="mr-4" />
								<span class="line-ellipsis-1 flex-1">{{ item.name | formatEmpty }}</span>
							</div>
							<div class="line-ellipsis-1 mt-2 color-gy-7 font-h6-regular" style="max-width: 220px">
								<span v-if="module.key === 'RankingDr'">{{ item.platform_id | formatPlatformName }}：</span>
								<span v-else>{{ module.infoTitle }}</span>
								{{ item.info | formatEmpty }}
							</div>
						</div>
					</div>
					<div style="width: 140px" class="flex-column flex-align-center flex-align-end">
						<div class="fz-16 Barlow-Bold" style="line-height: 20px">¥{{ item.money.toFixed(2) | formatEmpty | formatPrice2 }}</div>
						<div class="font-h6-regular mt-2 color-gy-7">订单金额</div>
					</div>
				</div>
				<div v-if="module.list.length === 0" class="flex-center flex-1">
					<Empty></Empty>
				</div>
			</div>
		</Panel>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getAnchorRank, getInstitutionRank, getProductRank, getStaffRank } from '@/api/home';

export default {
	name: '',
	components: {},
	props: {
		showKey: {
			type: String,
			default: 'RankingDr',
		},
		authorityId: {
			type: String,
			default: '',
		},
		platformId: {
			type: Number,
		},
		userIds: {
			type: Array,
			default: () => [],
		},
		deptIds: {
			type: Array,
			default: () => [],
		},
		params: {
			type: Object,
			default: _ => ({}),
		},
	},
	data() {
		return {
			icon: {
				0: require('@/assets/public/i-talentCRM-myTalentDetail-Rank-1@2x.png'),
				1: require('@/assets/public/i-talentCRM-myTalentDetail-Rank-2@2x.png'),
				2: require('@/assets/public/i-talentCRM-myTalentDetail-Rank-3@2x.png'),
			},
			roleMap: new Map([
				// value1是跳转的tabId，value2是请求接口的参数
				['talentBusiness', { title: '达人商务', value1: 1, value2: 3 }],
				['investmentPromotion', { title: '招商运营', value1: 2, value2: 2 }],
			]),
			rankModule: [],
		};
	},
	computed: {
		...mapGetters(['canShowPlatformList', 'platformVersion', 'defaultPlatform']),
		rankMap() {
			return new Map([
				[
					'RankingDr',
					{
						key: 'RankingDr',
						show: this.$auth.hasPermi('home:rankingTalent'),
						title: '达人排行',
						list: [],
						showImg: true,
						showMore: true,
						infoTitle: '抖音号：',
						loading: false,
						showIcon: true,
						platformSelect: true,
						platform_id: this.defaultPlatform,
					},
				],
				[
					'RankingGood',
					{
						key: 'RankingGood',
						show: this.$auth.hasPermi('home:rankingProduct'),
						title: '商品排行',
						list: [],
						showImg: true,
						showMore: true,
						infoTitle: '商品ID：',
						loading: false,
						showIcon: true,
						platformSelect: true,
						platform_id: this.defaultPlatform,
					},
				],
				[
					'RankingRc',
					{
						key: 'RankingRc',
						show: this.$auth.hasPermi('home:rankingCommander'),
						title: '二级团长排行',
						list: [],
						showImg: false,
						showMore: true,
						infoTitle: '团长ID：',
						loading: false,
						platformSelect: true,
						platform_id: this.defaultPlatform,
					},
				],
				[
					'RankingStaff',
					{
						key: 'RankingStaff',
						show: this.$auth.hasPermi('home:rankingStaff'),
						title: '员工排行',
						list: [],
						showImg: true,
						showMore: this.$auth.hasPermi('system:teamManage-query'),
						infoTitle: '部门：',
						loading: false,
						role: 'talentBusiness',
					},
				],
			]);
		},
		searchParameters() {
			return {
				platform_id: this.platformId,
				begin_time: this.params.from_time,
				end_time: this.params.to_time,
				deptIds: this.deptIds,
				userIds: this.userIds,
				authority_id: this.authorityId,
			};
		},
		module() {
			const item = this.rankModule.find(item => item.key === this.showKey);
			return item || {};
		},
		canShowPlatformListCom() {
			// 视频号没有二级团长
			return this.canShowPlatformList.filter(item => !(this.showKey == 'RankingRc' && this.$isSp(item.value)));
		},
	},
	watch: {
		platformId: {
			// 给各排行榜的平台赋值
			handler(val) {
				if (!this.platformVersion.includes(+val)) return;
				if (!this.$isAllPF(val)) {
					this.rankMap.set('RankingDr', { ...this.rankMap.get('RankingDr'), platform_id: val });
					this.rankMap.set('RankingGood', { ...this.rankMap.get('RankingGood'), platform_id: val });
					this.rankMap.set('RankingRc', { ...this.rankMap.get('RankingRc'), platform_id: val });
					this.rankModule = [...this.rankMap.values()];
				}
			},
			immediate: true,
		},
		searchParameters: {
			handler(val) {
				this.loadModule(this.showKey);
			},
			deep: true,
		},
	},
	created() {
		this.rankMap.set(this.showKey, { ...this.rankMap.get(this.showKey), key: this.showKey });
		this.rankModule = [...this.rankMap.values()];
	},
	methods: {
		loadModule(key) {
			const loadMap = new Map([
				['RankingDr', this.getDrList],
				['RankingGood', this.getGoodList],
				['RankingRc', this.getRcList],
				['RankingStaff', this.getStaffList],
			]);
			loadMap.get(key)();
		},
		// 下拉框切换平台或角色
		handleCommand(val, key) {
			if (key === 'RankingStaff') {
				this.rankMap.set(key, { ...this.rankMap.get(key), role: val });
			} else {
				this.rankMap.set(key, { ...this.rankMap.get(key), platform_id: val });
			}
			this.rankModule = [...this.rankMap.values()];
			this.loadModule(key);
		},
		skipUrl(platformId, key) {
			const startEndTime = [this.params.from_time, this.params.to_time].join(',');
			const skipMap = new Map([
				['RankingDr', { url: '/ranking/issueTalent', query: { platformId, startEndTime } }],
				['RankingGood', { url: '/ranking/issueProduct', query: { platformId, startEndTime } }],
				['RankingRc', { url: '/ranking/issueHeader', query: { platformId, startEndTime } }],
				[
					'RankingStaff',
					{
						url: '/teamManage/achievements',
						query: {
							platformId: this.platformId,
							startEndTime,
							authority_id: this.authorityId,
							staff_name: this.roleMap.get(this.rankMap.get('RankingStaff').role)['value1'],
						},
					},
				],
			]);
			const handLink = this.$router.resolve({
				path: skipMap.get(key).url,
				query: skipMap.get(key).query,
			});
			window.open(handLink.href, '_blank');
		},
		getDrList() {
			this.fetchDataAndProcess(
				'RankingDr',
				getAnchorRank,
				item => ({
					name: item.author_account,
					imgUrl: item.head,
					info: item.author_short_id,
					money: +item.money,
					platform_id: item.platform_id,
					key: item.author_short_id,
				}),
				{ platform_id: this.rankMap.get('RankingDr').platform_id },
			);
		},
		getGoodList() {
			this.fetchDataAndProcess(
				'RankingGood',
				getProductRank,
				item => ({
					name: item.product_name,
					info: item.third_product_id,
					imgUrl: item.product_img,
					money: +item.money,
					platform_id: item.platform_id,
					key: item.third_product_id,
				}),
				{ platform_id: this.rankMap.get('RankingGood').platform_id },
			);
		},
		getRcList() {
			this.fetchDataAndProcess(
				'RankingRc',
				getInstitutionRank,
				item => ({
					name: item.sec_institution_name,
					info: item.sec_institution_id,
					money: +item.money,
					key: item.sec_institution_id,
				}),
				{ platform_id: this.rankMap.get('RankingRc').platform_id },
			);
		},
		getStaffList() {
			const role = this.rankMap.get('RankingStaff').role;
			this.fetchDataAndProcess(
				'RankingStaff',
				getStaffRank,
				item => ({
					name: item.partner_name,
					imgUrl: item.avatar_url,
					info: item.dept_name,
					money: +item.money,
					key: item.partner_name,
				}),
				{ type: this.roleMap.get(role)['value2'] },
			);
		},
		// 请求接口，数据组装
		async fetchDataAndProcess(rankKey, apiFunction, dataMappingFunction, additionalParams = {}) {
			const rankObject = this.rankMap.get(rankKey);
			rankObject.loading = true;
			this.rankModule = [...this.rankMap.values()];
			try {
				const { code, data } = await apiFunction({
					...this.searchParameters,
					...additionalParams,
				});
				if (code === 0) {
					const formattedData = data.map(dataMappingFunction);
					this.dataProcess(formattedData, rankKey);
				} else {
					rankObject.loading = false;
					this.rankModule = [...this.rankMap.values()];
				}
			} catch (error) {
				console.error(`Error fetching data for ${rankKey}:`, error);
				rankObject.loading = false;
				this.rankModule = [...this.rankMap.values()];
			}
		},
		dataProcess(formattedData, itemKey) {
			this.rankMap.set(itemKey, { ...this.rankMap.get(itemKey), loading: false });
			const rankObj = { ...this.rankMap.get(itemKey), list: formattedData };
			this.rankMap.set(itemKey, rankObj);
			this.rankModule = Array.from(this.rankMap.values());
		},
	},
};
</script>

<style lang="less" scoped>
.homePage_inlinet {
	width: 50%;
	box-sizing: border-box;
	margin-top: 16px;

	&:nth-child(odd) {
		padding-right: 8px;
	}

	&:nth-child(even) {
		padding-left: 8px;
	}
	.home_inlineTitle_select {
		border: 1px solid #e2e3e8;
		width: 90px;
		height: 32px;
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;
		font-size: 12px;
		cursor: pointer;

		&:hover {
			border: 1px solid @color-primary;
		}
		&:focus {
			border: 1px solid @color-primary;
		}
	}
}
.rank-pannel {
	display: flex;
	/deep/ .panel-body {
		display: flex;
		width: 100%;
		box-sizing: border-box;
		flex-direction: column;
		.data-content {
			flex: 1;
			// display: flex
		}
	}
	.home_rankingItem {
		box-sizing: border-box;
		height: 68px;
		border-radius: 12px;
		.home_rankingItem_icon {
			width: 28px;
			height: 28px;
			flex-shrink: 0;
		}
	}
}
</style>
